import React from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col, Card, CardBody } from 'reactstrap'

const SaveConfirmationModal = ({
    isOpen,
    toggle,
    currentRule,
    newRule,
    onConfirm,
    loading = false
}) => {
    const formatRuleDisplay = (rule) => {
        if (!rule) return { type: 'None', value: 'No rule defined' }

        if (rule.type === 'LIT' || (rule.type === 'ALWAYS' && !rule.rules)) {
            return {
                type: 'Always',
                value: (rule.value === true || rule.value === 'True' || rule.value === 'TRUE') ? 'True' : 'False'
            }
        }

        // Handle EXPR without rules (legacy format)
        if (rule.type === 'EXPR' && !rule.rules) {
            return {
                type: 'Conditional',
                value: rule.value || 'No expression defined'
            }
        }

        if ((rule.type === 'EXPR' && rule.rules) || (rule.type === 'ALWAYS' && rule.rules)) {
            const conditions = []

            if (rule.rules.true_conditions?.any?.length > 0) {
                rule.rules.true_conditions.any.forEach(anyGroup => {
                    anyGroup.all?.forEach(condition => {
                        if (condition.op === 'in') {
                            const values = Array.isArray(condition.value) ? condition.value : [condition.value]
                            conditions.push(`${condition.field} in [${values.join(', ')}]`)
                        } else {
                            conditions.push(`${condition.field} ${condition.op} ${condition.value}`)
                        }
                    })
                })
            }

            return {
                type: 'Conditional',
                value: conditions.length > 0 ? conditions.join(' AND ') : 'No conditions defined'
            }
        }

        return {
            type: 'Unknown',
            value: String(rule.value || 'undefined')
        }
    }

    const currentDisplay = formatRuleDisplay(currentRule)
    const newDisplay = formatRuleDisplay(newRule)

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
            <ModalHeader toggle={toggle} className="bg-primary text-white">
                <i className="fas fa-save me-2"></i>
                Confirm Configuration Change
            </ModalHeader>
            <ModalBody className="p-4">
                <div className="mb-3">
                    <h6 className="text-primary">
                        <i className="fas fa-info-circle me-2"></i>
                        You are about to modify the configuration for: <strong>{newRule?.notes || newRule?.name}</strong>
                    </h6>
                    <p className="text-muted mb-4">Please review the changes below before proceeding.</p>
                </div>

                <Row>
                    <Col md="6">
                        <Card className="border-secondary">
                            <CardBody className="p-3">
                                <h6 className="text-secondary mb-3">
                                    <i className="fas fa-history me-2"></i>
                                    Current Configuration
                                </h6>

                                <div className="mb-2">
                                    <small className="text-muted fw-bold">Rule Type:</small>
                                    <div>
                                        <span className={`badge ${currentDisplay.type === 'Always' ? 'bg-secondary' : 'bg-warning'}`}>
                                            {currentDisplay.type}
                                        </span>
                                    </div>
                                </div>

                                <div className="mb-2">
                                    <small className="text-muted fw-bold">Value/Condition:</small>
                                    <div className="mt-1 p-2 bg-light rounded" style={{ fontSize: '0.875rem', fontFamily: 'monospace' }}>
                                        {currentDisplay.value}
                                    </div>
                                </div>

                            </CardBody>
                        </Card>
                    </Col>

                    <Col md="6">
                        <Card className="border-primary">
                            <CardBody className="p-3">
                                <h6 className="text-primary mb-3">
                                    <i className="fas fa-arrow-right me-2"></i>
                                    New Configuration
                                </h6>

                                <div className="mb-2">
                                    <small className="text-muted fw-bold">Rule Type:</small>
                                    <div>
                                        <span className={`badge ${newDisplay.type === 'Always' ? 'bg-secondary' : 'bg-warning'}`}>
                                            {newDisplay.type}
                                        </span>
                                    </div>
                                </div>

                                <div className="mb-2">
                                    <small className="text-muted fw-bold">Value/Condition:</small>
                                    <div className="mt-1 p-2 bg-light rounded" style={{ fontSize: '0.875rem', fontFamily: 'monospace' }}>
                                        {newDisplay.value}
                                    </div>
                                </div>

                            </CardBody>
                        </Card>
                    </Col>
                </Row>

            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={onConfirm} disabled={loading}>
                    <i className={`fas ${loading ? 'fa-spinner fa-spin' : 'fa-check'} me-1`}></i>
                    {loading ? 'Saving...' : 'Confirm & Save'}
                </Button>
                <Button color="secondary" onClick={toggle} disabled={loading}>
                    <i className="fas fa-times me-1"></i>
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default SaveConfirmationModal